import {IModel, IPoint} from "makerjs";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";

export enum DimensionLineType{
	primary = 'primary',
	secondary = 'secondary',
	default = 'default',
}
export default class DimensionLine {
	private readonly startPoint: IPoint;
	private readonly endPoint: IPoint;
	private readonly label: string;
	private readonly unit: string;
	private offset: IPoint;
	private ratio: number;
	private readonly type: DimensionLineType;

	constructor( startPoint: IPoint, endPoint: IPoint, label: string, offset: IPoint, ratio = 1, type = DimensionLineType.default, unit = 'cm' ) {
		this.startPoint = startPoint;
		this.endPoint = endPoint;
		this.label = label;
		this.unit = unit;
		this.offset = offset;
		this.ratio = ratio;
		this.type = type;
	}

	shiftOffset(shift: number): void {
		this.offset = [this.offset[0]*shift, this.offset[1]*shift];
	}

	getModel(): IModel {
		const model = {} as IModel;
		const subModel = {} as IModel;

		const baseLine = new makerjs.paths.Line(this.startPoint, this.endPoint);
		const angle = makerjs.angle.ofLineInDegrees(baseLine);

		// Add arrow to start of line
		const arrowStartLeft = new makerjs.paths.Line([this.startPoint[0], this.startPoint[1]], [this.startPoint[0] + (8 * this.ratio), this.startPoint[1]]);
		makerjs.path.rotate(arrowStartLeft, angle + 45, this.startPoint);
		const arrowStartRight = new makerjs.paths.Line([this.startPoint[0], this.startPoint[1]], [this.startPoint[0] + (8 * this.ratio), this.startPoint[1]]);
		makerjs.path.rotate(arrowStartRight, angle - 45, this.startPoint);

		// Add arrow to end of line
		const arrowEndLeft = new makerjs.paths.Line([this.endPoint[0], this.endPoint[1]], [this.endPoint[0] - (8 * this.ratio), this.endPoint[1]]);
		makerjs.path.rotate(arrowEndLeft, angle - 45, this.endPoint);
		const arrowEndRight = new makerjs.paths.Line([this.endPoint[0], this.endPoint[1]], [this.endPoint[0] - (8 * this.ratio), this.endPoint[1]]);
		makerjs.path.rotate(arrowEndRight, angle + 45, this.endPoint);

		// Create the base line with top and end arrows
		makerjs.model.addPath(model, baseLine, 'base-line');
		makerjs.model.addPath(model, arrowStartLeft, 'arrow-start-left');
		makerjs.model.addPath(model, arrowStartRight, 'arrow-start-right');
		makerjs.model.addPath(model, arrowEndLeft, 'arrow-end-left');
		makerjs.model.addPath(model, arrowEndRight, 'arrow-end-right');

		makerjs.model.addCaption(subModel, this.label, this.startPoint, this.endPoint);

		// Used to set an active state for the dimension line caption
		if (this.type === 'primary') {
			subModel.layer = 'white';
		}

		makerjs.model.addModel(model, subModel, 'cap');
		makerjs.model.moveRelative(model, [this.offset[0] * this.ratio, this.offset[1] * this.ratio]);

		return model;
	}

	getLength(): number {
		return makerjs.measure.pointDistance(this.startPoint, this.endPoint);
	}
}
